export default __webpack_public_path__ + "static/media/lr.367719d1.svg";